module.exports = __webpack_public_path__ + "fonts/DINPro-Black.74854099.otf";